import { useSyncExternalStore } from 'react';
import { useAuthStore } from './auth.store';

const PLATFORM_AUTH_KEY = 'bluechip-platform-auth';

type PersistedAuthState = {
  state?: {
    token?: string | null;
  };
};

function readPersistedPlatformToken(): string | null {
  if (typeof window === 'undefined') return null;

  const raw = window.localStorage.getItem(PLATFORM_AUTH_KEY);
  if (!raw) return null;

  try {
    const parsed = JSON.parse(raw) as PersistedAuthState;
    return parsed.state?.token || null;
  } catch {
    return null;
  }
}

export function getPlatformToken(): string | null {
  return useAuthStore.getState().token ?? readPersistedPlatformToken();
}

export function usePlatformSession() {
  const token = useAuthStore(s => s.token);
  const hydrated = useSyncExternalStore(
    onStoreChange => useAuthStore.persist.onFinishHydration(onStoreChange),
    () => useAuthStore.persist.hasHydrated(),
    () => false,
  );

  return {
    token: token ?? readPersistedPlatformToken(),
    hydrated,
  };
}
